import {Button, styled} from '@mui/material'

export const StyledButton = styled(Button)(() => ({
  height: '3rem',
}))
